/**
 * Trusted API request guard
 *
 * Determines whether a request URL targets the configured API base.
 * Used by interceptors that should only modify/inspect requests to our own backend.
 */
export function isTrustedApiRequest(url: string, apiBaseUrl?: string): boolean {
  if (!apiBaseUrl) {
    return false;
  }

  try {
    const requestUrl = url.startsWith('/')
      ? new URL(url, window.location.origin)
      : new URL(url);
    const apiUrl = new URL(apiBaseUrl, window.location.origin);
    const apiPathPrefix = apiUrl.pathname.replace(/\/$/, '');

    return requestUrl.origin === apiUrl.origin &&
      pathMatchesPrefix(requestUrl.pathname, apiPathPrefix);
  } catch {
    return false;
  }
}

export function pathMatchesPrefix(pathname: string, prefix: string): boolean {
  if (!prefix || prefix === '/') {
    return true;
  }
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}
